import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';

import YMMSelect from './YMMSelect';

const styles = {
  root: {
    display: 'flex',
    justifyContent: 'space-between',
    backgroundColor: 'white',
    padding: 15,
    margin: '10px 0px',
  },
  select: {
    flexGrow: 1,
    marginRight: 20,
    width: 150,
  },
};

const MAKE_ID = 'makeId';
const MODEL_ID = 'modelId';
const YEAR = 'year';

class YMMTPicker extends Component {
  constructor(...args) {
    super(...args);
    this.handleSelection = this.handleSelection.bind(this);
  }

  handleSelection({ field, value }) {
    const { makeId, modelId, year } = this.props;
    const update = Object.assign({ makeId, modelId, year }, { [field]: value });

    if (field === MAKE_ID) {
      delete update[MODEL_ID];
      delete update[YEAR];
    }

    if (field === MODEL_ID) {
      delete update[YEAR];
    }

    this.props.onYMMTChange(update);
  }

  render() {
    const { classes } = this.props;
    return (
      <Paper className={classes.root}>
        <YMMSelect
          label="Make"
          field={MAKE_ID}
          value={this.props.makeId}
          data={this.props.makes.list}
          classes={classes}
          loading={this.props.makes.loading ? 'Getting Makes...' : null}
          error={this.props.makes.error ? 'Error Getting Makes' : null}
          handleSelection={this.handleSelection}
        />
        <YMMSelect
          label="Model"
          field={MODEL_ID}
          value={this.props.modelId}
          data={this.props.models}
          classes={classes}
          loading={this.props.models.loading ? 'Getting Models...' : null}
          error={this.props.models.error ? 'Error Getting Makes' : null}
          handleSelection={this.handleSelection}
        />
        <YMMSelect
          label="Year"
          field={YEAR}
          value={this.props.year}
          data={this.props.years}
          classes={classes}
          handleSelection={this.handleSelection}
        />
      </Paper>
    );
  }
}

YMMTPicker.propTypes = {
  makes: PropTypes.object,
  models: PropTypes.arrayOf(PropTypes.object),
  years: PropTypes.arrayOf(PropTypes.string),
  makeId: PropTypes.string,
  modelId: PropTypes.string,
  year: PropTypes.string,
  classes: PropTypes.object,
  onYMMTChange: PropTypes.func,
};

YMMTPicker.defaultProps = {
  onYMMTChange: () => {},
  makeId: '',
  modelId: '',
  year: '',
};

export default withStyles(styles)(YMMTPicker);



// WEBPACK FOOTER //
// ./src/settings/components/YMMPicker.jsx